var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
// src/services/authService.ts
import jwtDecode from 'jwt-decode';
import axiosDefault from 'axios';
import * as axiosModule from 'axios';
import { logger } from '../utils/logger';
import { ApiConfig } from '../infrastructure/config/apiConfig';
var AUTH_STORAGE_KEYS = {
    ROLES: 'roles',
    PERMISSIONS: 'permissions',
    TOKEN: 'token',
};
var axiosClient = ((_a = axiosModule.default) !== null && _a !== void 0 ? _a : axiosDefault);
var normalizeAuthResponse = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var value = (_a = data === null || data === void 0 ? void 0 : data.value) !== null && _a !== void 0 ? _a : {};
    var token = (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.token) !== null && _b !== void 0 ? _b : data === null || data === void 0 ? void 0 : data.accessToken) !== null && _c !== void 0 ? _c : value.token) !== null && _d !== void 0 ? _d : value.accessToken;
    if (!token) {
        throw new Error('Auth response does not include a user token.');
    }
    return {
        token: token,
        roles: (_f = (_e = data === null || data === void 0 ? void 0 : data.roles) !== null && _e !== void 0 ? _e : value.roles) !== null && _f !== void 0 ? _f : [],
        permissions: (_h = (_g = data === null || data === void 0 ? void 0 : data.permissions) !== null && _g !== void 0 ? _g : value.permissions) !== null && _h !== void 0 ? _h : [],
        username: (_j = data === null || data === void 0 ? void 0 : data.username) !== null && _j !== void 0 ? _j : value.username,
        expiration: (_k = data === null || data === void 0 ? void 0 : data.expiration) !== null && _k !== void 0 ? _k : value.expiration,
    };
};
/**
 * Datos de usuario de la sesión. El nombre es el username de la respuesta de Security en los
 * dos logins, para no romper la continuidad de la auditoría.
 */
export var toSessionUser = function (authResponse, fallbackName) {
    if (fallbackName === void 0) { fallbackName = ''; }
    return ({
        name: authResponse.username || fallbackName,
        roles: authResponse.roles || [],
        permissions: authResponse.permissions || [],
    });
};
/** Código HTTP de un error de axios, si lo tiene. */
export var getHttpStatus = function (error) { var _a; return (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status; };
/**
 * Autentica un usuario contra Security. La llamada va sin Authorization:
 * el canal se autentica en plataforma (APIM / Easy Auth con Entra ID).
 */
export var getAuth = function (username, password) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosClient.post("".concat(ApiConfig.securityApiBaseUrl).concat(ApiConfig.securityPath('/Auth/Backoffice')), {
                        username: username,
                        password: password,
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, normalizeAuthResponse(response.data)];
            case 2:
                error_1 = _a.sent();
                logger.error('❌ Error en la autenticación:', error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
/** Restablece la contraseña sin JWT de sesión ni interceptores de rutas protegidas. */
export var resetBackofficePassword = function (_a) {
    var password = _a.password, resetToken = _a.resetToken;
    return __awaiter(void 0, void 0, void 0, function () {
        var status, response, error_2;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axiosClient.put(ApiConfig.securityApiBaseUrl + ApiConfig.securityPath('/Auth/Backoffice/Password'), {
                            password: password,
                            resetToken: resetToken,
                        })];
                case 1:
                    response = _c.sent();
                    if (response.status === 200)
                        return [2 /*return*/];
                    status = response.status;
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _c.sent();
                    status = (_b = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _b === void 0 ? void 0 : _b.status;
                    return [3 /*break*/, 3];
                case 3: 
                // Conservar solo el estado HTTP: los errores Axios pueden incluir contraseña y token en config.data.
                throw Object.assign(new Error('Password reset failed.'), { status: status });
            }
        });
    });
};
/**
 * Canjea el access token de Entra por el JWT de backoffice de Security. Igual que getAuth, va
 * sin Authorization; el token de Entra viaja en el body (wiki §4.2).
 */
export var exchangeEntraToken = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axiosClient.post("".concat(ApiConfig.securityApiBaseUrl).concat(ApiConfig.securityPath('/Auth/Backoffice/Entra')), {
                        accessToken: accessToken,
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, normalizeAuthResponse(response.data)];
            case 2:
                error_3 = _a.sent();
                // Solo el código HTTP: el error de axios incluye el body de la petición, con el token.
                logger.error('❌ Error en el canje del token de Entra. HTTP', getHttpStatus(error_3));
                throw error_3;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Verifica si un token JWT ha expirado
 */
export var isTokenExpired = function (token) {
    if (!token)
        return true;
    try {
        var decoded = jwtDecode(token);
        var currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        var tokenExpired = decoded.exp < currentTime;
        if (tokenExpired) {
            logger.debug("\uD83D\uDD0D Token expirado ".concat(tokenExpired));
        }
        return tokenExpired;
    }
    catch (error) {
        logger.error('❌ Error al decodificar el token:', error);
        return true; // Si falla la decodificación, asumir que expiró
    }
};
/**
 * Indica si al token le quedan `seconds` segundos de vida o menos
 */
export var isTokenExpiringWithin = function (token, seconds) {
    try {
        var decoded = jwtDecode(token);
        return decoded.exp - Math.floor(Date.now() / 1000) <= seconds;
    }
    catch (_a) {
        return true;
    }
};
/**
 * Borra toda la información de autenticación del localStorage
 */
export var logout = function () {
    Object.values(AUTH_STORAGE_KEYS).forEach(function (key) { return localStorage.removeItem(key); });
};
/**
 * Obtiene el token almacenado en localStorage
 */
export var getStoredToken = function () {
    return localStorage.getItem(AUTH_STORAGE_KEYS.TOKEN);
};
